import {type ReactElement} from 'react';
import {useAiChat} from '@/ai-chat/providers/ai-chat.context';
import {AiAgentMode} from '@/ai-chat/providers/ai-chat-provider.types';
import styles from './agent-mode-pill.module.scss';

export function AgentModePill(): ReactElement | null {
  const {state} = useAiChat();

  if (!state.isSuperUser || state.mode !== AiAgentMode.AGENT) {
    return null;
  }

  return <div className={styles.agentModePill}>{window.i18next.t('pmwjs_ai_agent_mode_pill')}</div>;
}
